import React from 'react'
import AuthenticationPresentation from '../../../components/Admin/Authentication'
import { AdminContainer } from '../'
import PageHeaderContainer from 'shared/components/PageHeader/container'

export default function Authentication() {
  return (
    <React.Fragment>
      <PageHeaderContainer title="Authentication security" />
      <AdminContainer>
        <div className="ui segment admin-section">
          <AuthenticationPresentation />
        </div>
      </AdminContainer>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Authentication/index.js